/* Used by Storefront */
import React from "react";
import { cls } from "cls";
import { LinkedResourceResult } from "~/common/Store/models/Category";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
interface Props {
  index: number;
  resource: LinkedResourceResult;
}

/* Blog or UserReview resource type */
const TextResource = ({
  index,
  resource
}: Props) => <div id={`SHQ-fsr-${index}`} className={cls("group", "bg-white", "border-gray-200", "rounded-none", "border-solid", "border", "border-t-0", "first:border-t", "last:border-b-0", "box-border", "float-left", "mb-0", "overflow-hidden", "p-4", "relative", "shadow-none", "w-full", "xs:first:rounded-t", "lt:rounded", "lt:border-0", "lt:mb-5", "lt:p-0", "lt:shadow-sm")} data-testid="fsr-item" data-sentry-component="TextResource" data-sentry-source-file="TextResource.tsx">
    <a href={resource.link} target="_blank">
      <div className={cls("bg-black", "block", "float-left", "overflow-hidden", "relative", "z-0", "lt:float-none", "lt:w-full")}>
        <NoScriptLazyImage className={cls("bg-white", "h-20", "object-cover", "group-hover:opacity-75", "w-32", "ease-in-out", "duration-100", "lt:h-32", "lt:w-128")} src={resource.image} alt={resource.title} dataTestId="image" data-sentry-element="NoScriptLazyImage" data-sentry-source-file="TextResource.tsx" />
      </div>
      <div className={cls("block", "overflow-hidden", "py-2", "px-4")}>
        <p className={cls("font-semibold", "text-base", "leading-none", "m-0", "text-gray-800")}>
          {resource.title}
        </p>
        <a className={cls("font-bold", "hover:text-green-800", "text-green-500", "text-xs")} href={resource.link} target="_blank">
          Read More
        </a>
      </div>
    </a>
  </div>;
export default TextResource;